import React, { ReactElement } from 'react';
import {
  Col, Link, Row, Text,
} from 'idsk-react-components';
import mapDate from '../../../function/mapDate';
import routes from '../../../routing/routes';
import './prispevokVestnikaListRow.scss';
import PrispevokVestnikaListItem from '../../../model/PrispevokVestnikaListItem';

interface Props {
  rezortnaZbierka: PrispevokVestnikaListItem;
}

const PrispevokVestnikaListRow = ({
  rezortnaZbierka,
}: Props): ReactElement => (
  <div className="prispevok-vestnika-list-row">
    <Row>
      <Col width="one-third" className="prispevok-vestnika-list-column__third first_col">Číslo
      </Col>
      <Col width="one-third" className="prispevok-vestnika-list-column__third">Dátum zverejnenia
      </Col>
      {rezortnaZbierka.datumUcinnosti && (
        <Col width="one-third" className="prispevok-vestnika-list-column__third">Dátum účinnosti
        </Col>
      )}
    </Row>
    <Row className="row-container-prispevok-vestnika-values">
      <Col width="one-third" className="prispevok-vestnika-list-column__third first_col">
        <Text type="span" bold>{rezortnaZbierka.cislo}</Text>
      </Col>
      <Col width="one-third" className="prispevok-vestnika-list-column__third">
        <Text type="span" bold>{mapDate(rezortnaZbierka.datumZverejnenia)}</Text>
      </Col>
      <Col width="one-third" className="prispevok-vestnika-list-column__third">
        <Text type="span" bold>{mapDate(rezortnaZbierka.datumUcinnosti)}</Text>
      </Col>
    </Row>
    <Row className="nazov-link-container">
      <Col width="full">
        <Link
          className="nazov-link"
          to={routes.prispevokVestnika.detail.withParams(rezortnaZbierka.uuid)}
        >
          {rezortnaZbierka.nazov}
        </Link>
      </Col>
    </Row>
  </div>
);
export default PrispevokVestnikaListRow;
